export class CityVo{
    name:string;
    id: number;
    group:string;
}